export enum ModalRoutes {
  MobileFiltersScreen = '/mtt/mobile-filters-screen',
  MobileSidecarScreen = '/mtt/sidecar-screen'
}
